module.exports = __webpack_public_path__ + "img/mcwhorterhall-h-474x356.d1c88542.jpg";